import { request } from 'api/request';
import { PRODUCT_RESEARCH_API_URLS } from 'api/constants';

export default class Categories {
  static getCategories() {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.categories.getCategories,
    });
  }
}
